'use strict';

angular.module('game')
  .controller('onboardingCtrl', ['$scope', 'gameSettings', 'globalService', 'i18nService', '$location', 'playerService',
    function ($scope, gameSettings, globalService, i18nService, $location, playerService) {

      $scope.contentURL = globalService.gameConstants.contentURL;
      $scope.mediaURL = globalService.gameConstants.mediaURL;

      i18nService.getLocale().then(function (locale) {
        $scope.locale = locale;

        globalService.userService.getUser().then(function (user) {

          var videoPlayer = playerService.create("element");

          if ($scope) {
            videoPlayer.attachToScope($scope);
          }
          var setup = {
            'file': $scope.mediaURL + locale['front.onboarding.video'],
            'mediaid': $scope.mediaURL + locale['front.onboarding.video'],
            'autostart': true,
            'controls': true,
            'poster': $scope.contentURL + 'images/challenges/satelite.png',
            'tracks': [{
              'file': $scope.mediaURL + locale['front.onboarding.video'] + "." + user.language + ".vtt",
              'kind': "captions",
              "default": true
            }],
            'captions': gameSettings.settings.videoPlayer.settings.captions,
            events: {
              onReady: function () {
                videoPlayer.play();
              },
              onComplete: function () {
                videoPlayer.remove();
                $location.path('/home');
                $scope.$apply();
              },
            }
          };
          // Initialize player
          videoPlayer.setup(setup);
        });
      });

      $scope.$emit("pageChange", {
        page: "onboarding"
      });

      $scope.home = function () {
        $location.path('/home');
      };

    }
  ]);
